// The header shares the Summit Pipeline's classes; nothing else loads them.
import '../Pipeline/Pipeline.scss';
import './HscPipelineFees.scss';
import Component from './HscPipelineFees.js';
export default Component;